import React from "react"
import { FC, PropsWithChildren } from "react"
import { SecurityHeader } from "./SecurityHeader"
import { SecuritySidebar } from "./SecuritySidebar"

export const SecurityLayout: FC<PropsWithChildren<{}>> = ({ children }) => {
    return (
        <div className="login-wrapper">
            <SecurityHeader customer={true} />
            <SecuritySidebar />
            <div className="login-content-wrap">
                {children}
            </div>
        </div>
    )
}
